/**
 * 食事シートのタブ（検索・AI・お気に入り・履歴・DB）
 * どのタブからでもほかのタブへ直接移れる。5 つ並ぶのでアイコンと名前を縦に積む
 */

import { cn } from '@/lib/utils'

import { SHEET_TABS } from './food-lists'
import type { SheetTab } from './palette-utils'

type Props = {
  value: SheetTab
  onChange: (tab: SheetTab) => void
}

export function SheetTabs({ value, onChange }: Props) {
  return (
    <div role="tablist" className="flex gap-1">
      {SHEET_TABS.map(({ kind, label, shortLabel, Icon, color }) => {
        const active = kind === value
        return (
          <button
            key={kind}
            type="button"
            role="tab"
            aria-selected={active}
            aria-label={label}
            onClick={() => onChange(kind)}
            className={cn(
              'flex min-w-0 flex-1 flex-col items-center gap-0.5 rounded-md px-1! py-1! text-[11px] transition-colors',
              active ? 'bg-accent font-medium text-foreground' : 'text-muted-foreground hover:bg-accent/50',
            )}
          >
            <Icon className={cn('size-4', color)} />
            <span className="max-w-full truncate">{shortLabel}</span>
          </button>
        )
      })}
    </div>
  )
}
